(function () {
  try {
    const MAX_WORDS = 3;

    const countWords = (str) => str.trim().split(/\s+/).filter(Boolean).length;
    const trimToWords = (str, n) =>
      str.trim().split(/\s+/).filter(Boolean).slice(0, n).join(" ");

    // Find nearest product “root” so we don't grab other selects/buttons on the page
    const getRoot = (el) =>
      el.closest('.shopify-section, [data-section-id], main, body') || document;

    const findVariantSelect = (root) => {
      const selects = Array.from(root.querySelectorAll("select"));
      // Must contain 1/2/3 Word options
      return selects.find((s) => {
        const t = Array.from(s.options || []).map(o => (o.textContent || "").trim()).join(" | ");
        return /1\s*Word/i.test(t) && /2\s*Words?/i.test(t) && /3\s*Words?/i.test(t);
      }) || null;
    };

    const selectedWordCount = (select) => {
      const txt = select?.options?.[select.selectedIndex]?.textContent || "";
      const m = txt.match(/(\d+)\s*Word/i);
      return m ? parseInt(m[1], 10) : null;
    };

    const findAddToCartButton = (root) => {
      // Rebel themes vary; cover common patterns
      const selectors = [
        'button[name="add"]',
        'button[type="submit"]',
        'input[type="submit"]',
        '[data-add-to-cart]',
        '[data-product-add-to-cart]',
        '#AddToCart',
        '#AddToCartButton',
        '.product-form__submit',
        '.add-to-cart',
        '.button--add-to-cart'
      ];
      for (const sel of selectors) {
        const btn = root.querySelector(sel);
        if (btn) return btn;
      }

      // last resort: find a button with text "Add to cart"
      const buttons = Array.from(root.querySelectorAll("button"));
      return buttons.find(b => /add to cart/i.test((b.textContent || "").trim())) || null;
    };

    const setDisabledState = (btn, disabled) => {
      if (!btn) return;
      btn.disabled = !!disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      btn.style.opacity = disabled ? "0.6" : "";
      btn.style.cursor = disabled ? "not-allowed" : "";
    };

    const init = () => {
      document.querySelectorAll(".custom-label-words").forEach((container) => {
        const input = container.querySelector("#label-text");
        const counter = container.querySelector("#word-count");
        const warning = container.querySelector("#word-warning");
        if (!input || !counter || !warning) return;

        const root = getRoot(container);
        const variantSelect = findVariantSelect(root);
        const atcBtn = findAddToCartButton(root);

        const validate = () => {
          let val = input.value;
          let words = countWords(val);

          if (words > MAX_WORDS) {
            val = trimToWords(val, MAX_WORDS);
            input.value = val;
            words = MAX_WORDS;
          }

          counter.textContent = `${words}/${MAX_WORDS} words`;

          // empty text = don't block
          if (words === 0 || !variantSelect) {
            warning.style.display = "none";
            setDisabledState(atcBtn, false);
            return;
          }

          const chosen = selectedWordCount(variantSelect);
          const ok = chosen === words;

          warning.style.display = ok ? "none" : "block";
          setDisabledState(atcBtn, !ok);
        };

        input.addEventListener("input", validate);
        root.addEventListener("change", validate);

        validate();
      });
    };

    document.addEventListener("DOMContentLoaded", init);
    document.addEventListener("shopify:section:load", init);
    document.addEventListener("shopify:section:select", init);
  } catch (e) {
    console.error("custom-label-words.js error:", e);
  }
})();
// ------------------------------
// Let’s Go Label — House/Bin Numbers (Max 3 chars)
// Forces correct "Number of Characters" variant selection
// ------------------------------
(function () {
  function initHouseNumbers() {
    const blocks = document.querySelectorAll("[data-ll-house-number]");
    if (!blocks.length) return;

    blocks.forEach((block) => {
      const formId = block.getAttribute("data-ll-form-id");
      const input = block.querySelector("[data-ll-house-input]");
      const countEl = block.querySelector("[data-ll-house-count]");
      const warnEl = block.querySelector("[data-ll-house-warning]");
      const form = formId ? document.getElementById(formId) : null;

      if (!input || !countEl || !warnEl || !form) return;

      const atcBtn =
        form.querySelector('button[type="submit"]') ||
        form.querySelector('[type="submit"]');

      // This is the exact selector you showed in DevTools
      const charSelect = document.querySelector(
        'select[name="options[Number of Characters]"]'
      );

      if (!atcBtn || !charSelect) return;

      function sanitize(v) {
        return (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
      }

      function selectedCount() {
        const t = charSelect.options[charSelect.selectedIndex]?.text || "";
        const m = t.match(/(\d+)/);
        return m ? parseInt(m[1], 10) : null;
      }

      function setState(valid, msg) {
        if (valid) {
          warnEl.style.display = "none";
          atcBtn.disabled = false;
        } else {
          warnEl.textContent = msg || "";
          warnEl.style.display = msg ? "block" : "none";
          atcBtn.disabled = true;
        }
      }

      function validate() {
        const clean = sanitize(input.value);
        if (input.value !== clean) input.value = clean;

        const len = clean.length;
        countEl.textContent = `${len}/3 characters`;

        // Empty = disable ATC, no warning
        if (len === 0) {
          setState(false, "");
          return;
        }

        if (len > 3) {
          setState(false, "Maximum 3 characters allowed.");
          return;
        }

        const sel = selectedCount();
        if (!sel) {
          setState(false, "Please choose the number of characters above.");
          return;
        }

        if (len !== sel) {
          setState(false, "Please choose the correct number of characters above.");
          return;
        }

        setState(true);
      }

      // Default lock until valid
      atcBtn.disabled = true;
      validate();

      input.addEventListener("input", validate);
      charSelect.addEventListener("change", validate);

      form.addEventListener(
        "submit",
        function (e) {
          validate();
          if (atcBtn.disabled) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    });
  }

  document.addEventListener("DOMContentLoaded", initHouseNumbers);
  document.addEventListener("shopify:section:load", initHouseNumbers);
})();